import cursor_rotate_n from "./cursors/cursor_rotate_n.svg?url"
import cursor_rotate_ne from "./cursors/cursor_rotate_ne.svg?url"
import cursor_rotate_e from "./cursors/cursor_rotate_e.svg?url"
import cursor_rotate_se from "./cursors/cursor_rotate_se.svg?url"
import cursor_rotate_s from "./cursors/cursor_rotate_s.svg?url"
import cursor_rotate_sw from "./cursors/cursor_rotate_sw.svg?url"
import cursor_rotate_w from "./cursors/cursor_rotate_w.svg?url"
import cursor_rotate_nw from "./cursors/cursor_rotate_nw.svg?url"
import cursor_pipette from "./custom/pipette.svg?url"

export const cursors = {
	cursor_rotate_n,
	cursor_rotate_ne,
	cursor_rotate_e,
	cursor_rotate_se,
	cursor_rotate_s,
	cursor_rotate_sw,
	cursor_rotate_w,
	cursor_rotate_nw,
}

export const pipetteCursor = cursor_pipette
